import MetricsDistributions from "../metrics-distributions";
import { Box, BoxContent } from "@edgetier/client-components";
import { Button, SpinnerUntil } from "@edgetier/components";
import { createQueryParameters } from "../metrics-distributions/metrics-distributions.utilities";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FunctionComponent, memo } from "react";
import { IExploreFilters } from "components-for/filters/explore-filters/explore-filters.types";
import { IInteractionMetricsNumericDistributions } from "@edgetier/watchtower-types";
import { IProps } from "./metrics-distributions-wrapper.types";
import { useFormikContext } from "formik";
import { useInteractionQueryParameters } from "hooks-for/filters/use-interaction-query-parameters";
import { useMetricDistribution } from "hooks-for/metrics/use-metric-distributions";
import "./metrics-distributions-wrapper.scss";

/**
 * Container for metrics distributions.
 * @param props.metricType Metric selected.
 * @param props.close      Close callback for opened tooltip.
 */
const MetricsDistributionsWrapper: FunctionComponent<IProps> = ({
    close,
    maximumFieldName,
    metricType,
    minimumFieldName,
}) => {
    const interactionQueryParameters = useInteractionQueryParameters();
    const { values: formValues } = useFormikContext<IExploreFilters>();

    const searchValues = createQueryParameters(
        minimumFieldName,
        maximumFieldName,
        interactionQueryParameters,
        formValues
    );

    const {
        data: metricDistribution,
        isLoading,
        isError,
    } = useMetricDistribution(metricType, searchValues, {
        enabled: typeof metricType !== undefined,
    });

    return (
        <Box className="interaction-metrics-distribution">
            <BoxContent>
                <SpinnerUntil<IInteractionMetricsNumericDistributions[]> data={metricDistribution} isReady={!isLoading}>
                    {(data) => {
                        return !isError && Array.isArray(data) && data.length > 0 ? (
                            <MetricsDistributions
                                close={close}
                                maximumFieldName={maximumFieldName}
                                metricData={data}
                                metricType={metricType}
                                minimumFieldName={minimumFieldName}
                            />
                        ) : (
                            <>
                                <div className="interaction-metrics-distribution__chart--empty">No data found</div>
                                <div className="interaction-metrics-distribution__buttons">
                                    <Button
                                        className="button--cancel"
                                        icon={faTimes}
                                        styleName="neutral"
                                        type="button"
                                        onClick={close}
                                    >
                                        Close
                                    </Button>
                                </div>
                            </>
                        );
                    }}
                </SpinnerUntil>
            </BoxContent>
        </Box>
    );
};

export default memo(MetricsDistributionsWrapper);
